import React from 'react'

interface AiClerkAvatarProps {
  /** 渲染尺寸（宽高相同），默认 32，与 HomeV3 会话 header 保持一致 */
  size?: number
}

/**
 * AI 填表员统一 logo 徽标（紫渐变圆 + ✦ 图形）。
 * 使用 SVG 实现，避免 CSS 背景/字体在宿主样式中失效。
 * 所有入口（HomeV3 会话 header、PhotoReportEntry、SafetyDocEntry）复用此组件。
 */
export default function AiClerkAvatar({ size = 32 }: AiClerkAvatarProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ flexShrink: 0, display: 'block' }}
    >
      <rect width="32" height="32" rx="16" fill="url(#aiClerkAvatarGrad)" />
      <path
        d="M15.31 22.088C15.2073 21.4813 14.9367 20.828 14.498 20.128C14.0593 19.4187 13.434 18.7607 12.622 18.154C11.8193 17.5473 11.0167 17.16 10.214 16.992V16.404C11.0073 16.2173 11.768 15.872 12.496 15.368C13.2333 14.8547 13.8493 14.2387 14.344 13.52C14.848 12.7827 15.17 12.0547 15.31 11.336H15.898C15.982 11.8027 16.15 12.2833 16.402 12.778C16.654 13.2633 16.976 13.73 17.368 14.178C17.7693 14.6167 18.2173 15.0133 18.712 15.368C19.4493 15.8907 20.2007 16.236 20.966 16.404V16.992C20.4527 17.0947 19.9207 17.3047 19.37 17.622C18.8287 17.9393 18.3247 18.3173 17.858 18.756C17.3913 19.1853 17.0087 19.638 16.71 20.114C16.2713 20.814 16.0007 21.472 15.898 22.088H15.31Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="aiClerkAvatarGrad"
          x1="0"
          y1="0"
          x2="22.6308"
          y2="22.6308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7C5CF5" />
          <stop offset="1" stopColor="#5B3EE0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
